import type { ApprovalInboxPaymentScope, ApprovalInboxQuery } from '@metycle/shared';

export const approvalsInboxKeys = {
  all: ['approvals-inbox'] as const,
  list: (query: ApprovalInboxQuery) => [...approvalsInboxKeys.all, 'list', query] as const,
  count: (paymentScope: ApprovalInboxPaymentScope = 'all') =>
    [...approvalsInboxKeys.all, 'count', paymentScope] as const,
};
